import { PROPERTY_STATUS } from '../settings-devices-configuration-layout/constants';
import {
    DeviceConfigurationInstance,
    DeviceLayoutConfigSectionDetails,
    VisibilityStatusModel,
} from '../settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { DeviceLayoutConfigSectionDetailsAPI } from './device-layout-config.api';
import { DeviceSettingsConfigAPI } from './device-settings-config.api';

const mapVisibilityStatus = (status: string): VisibilityStatusModel => {
    if (
        status === PROPERTY_STATUS.ENABLED ||
        status === PROPERTY_STATUS.DISABLED ||
        status === PROPERTY_STATUS.HIDDEN
    ) {
        return status;
    }

    return PROPERTY_STATUS.ENABLED;
};

export const mapSectionDetailsApiToModel = (
    sectionDetails: DeviceLayoutConfigSectionDetailsAPI
): DeviceLayoutConfigSectionDetails => ({
    ...sectionDetails,
    headers: sectionDetails.headers.map((header) => ({
        ...header,
        status: mapVisibilityStatus(header.status),
    })),
});

export const mapSettingsDeviceConfigurationApiToModel = (
    settings: DeviceSettingsConfigAPI
): DeviceConfigurationInstance => ({
    ...settings,
    properties: settings.properties.reduce<Record<string, unknown>>((acc, property) => {
        // Convert single value arrays to a single value. If is a combo check box continue to use array
        acc[property.name as string] = property.values.length === 1 ? property.values[0] : property.values;
        return acc;
    }, {}) as Record<string, unknown>,
});
